import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';


import img1 from '../../assets/images/img1.png';
import img2 from '../../assets/images/img2.png';
import img3 from '../../assets/images/img3.png';

const AuthCarousel = () => {
    const images = [img1, img2, img3];

    return (
        <div className="auth-carousel-container">
            <Carousel
                autoPlay={true}
                interval={5000}
                infiniteLoop={true}
                showThumbs={false}
                showIndicators={true}
                showStatus={false}
                stopOnHover={false}
                showArrows={false}
            >
                {images.map((img, index) => (
                    <div key={index} className="auth-carousel-slide">
                        <img src={img} alt={`Slide ${index + 1}`} className="auth-carousel-image" />
                    </div>
                ))}
            </Carousel>
        </div>
    );
};

export default AuthCarousel;
